import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route,useRouteMatch } from 'react-router-dom';
import { Switch } from 'react-router-dom';

import { LoadingSpinner } from 'brand-guidelines/Loading-styled-components';
import { requestUserAndPatient } from 'connect/actions';
import { selectDataLoadingUser } from 'connect/selectors';
import { useCurrentCheckoutStep } from 'pages/checkout/hooks/checkoutStepHooks';

import { usePrevious } from 'utils/customHooks/usePrevious';

export const CurrentStep = () => {
  const dispatch = useDispatch();
  const { url: rawUrl, path } = useRouteMatch();
  const url = rawUrl.replace(/\/$/, '');

  const [isLoading, setLoading] = useState(true);

  const { currentStep, currentStepIndex, applicableStepDefinitions } = useCurrentCheckoutStep();
  const isLoadingLogin = useSelector(selectDataLoadingUser);
  const previousIsLoadingLogin = usePrevious(isLoadingLogin);

  useEffect(() => {
    dispatch(requestUserAndPatient());
  }, [dispatch]);

  useEffect(() => {
    // Only setloading to false when the login was previously loading
    // And is no longer loading. So we wait for the login to start loading.
    // This prevents certain steps from being marked as inapplicable
    // before the user has loaded.
    // If we didn't do this, the user would always be redirected to the
    // first step when entering the checkout directly via URL.
    if (previousIsLoadingLogin && !isLoadingLogin) {
      setLoading(false);
    }
  }, [isLoadingLogin, previousIsLoadingLogin]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Slice to include up to the next step
  // +1 for the current step, +1 since slice is exclusive
  const validStepDefinitions = applicableStepDefinitions.slice(0, currentStepIndex + 1);

  return (
    <Switch>
      {validStepDefinitions.map((stepDefinition) => (
        <Route
          key={stepDefinition.id}
          path={`${path}/${stepDefinition.path}`}
        >
          <stepDefinition.component />
        </Route>
      ))}
      <Route>
        <Redirect to={`${url}/${currentStep?.path}`} />
      </Route>
    </Switch>
  );
};
